const drawer = document.getElementById('lds-contact-drawer');
const drawerInner = drawer.querySelector('.lds-contact-drawer_inner');
const overlay = document.getElementById('lds-contact-overlay');
const closeBtn = document.getElementById('CloseContact');
const openBtn = document.getElementById('lds-contact-toggle'); // ID bouton

const openDrawer = () => {
  drawer.classList.remove('translate-x-full');
  drawer.classList.add('translate-x-0');

  overlay.classList.remove('opacity-0', 'pointer-events-none');
  overlay.classList.add('opacity-50');

  document.body.classList.add('overflow-hidden');
};

const closeDrawer = () => {
  drawer.classList.add('translate-x-full');
  drawer.classList.remove('translate-x-0');

  overlay.classList.remove('opacity-50');
  overlay.classList.add('opacity-0');

  setTimeout(() => {
    overlay.classList.add('pointer-events-none');
    document.body.classList.remove('overflow-hidden');
  }, 300);
};

// ouverture via bouton
openBtn?.addEventListener('click', openDrawer);

// fermeture via bouton
closeBtn?.addEventListener('click', closeDrawer);

// fermeture via clic en dehors de l'intérieur du drawer
drawer.addEventListener('click', (event) => {
  if (!drawerInner.contains(event.target)) {
    closeDrawer();
  }
});

// Shopify édition : ouverture uniquement si section sélectionnée
if (window.Shopify && window.Shopify.designMode) {
  const sectionId = drawer.dataset.sectionId;

  document.addEventListener('shopify:section:select', (event) => {
    if (event.detail.sectionId === sectionId) {
      openDrawer();
    }
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.detail.sectionId === sectionId) {
      closeDrawer();
    }
  });
}
